import React from "react";

import "../styles.scss";
import "../scripts";

import {
  secondaryBlock,
  SecondaryBlockSize,
  KameleonElement,
  SecondaryBlockConfig,
  getDefaultProps,
  FCSecondaryBlock,
} from "@kameleon-core/lib";
import SecondaryTwoCol from "@kameleon-section/points-two-col-v1";
import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import { PointsType, layoutOptions } from "./types/prop-types";

/** Points Secondary */
const blockConfig: SecondaryBlockConfig = {
  blockSize: SecondaryBlockSize.Medium,
};

const TwoCol = SecondaryTwoCol.component as FCSecondaryBlock<any>;

export const Points = secondaryBlock<PointsType>(
  blockConfig,
  ({ ...props }: PointsType) => (
    <TwoCol
      _internalProps={{
        _className: "secondary-points-one-col-v1",
      }}
      {...props}
    />
  )
);

Points.defaultProps = getDefaultProps<PointsType>(defaults);

export const Element: KameleonElement = {
  component: Points,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
